import React, { useCallback } from "react";
import { useLocation } from "wouter";
import { AccountEmptyState } from "../../../components/States";

export const FinancesFirstRunState: React.FC = () => {
  const [, setLocation] = useLocation();

  const onAddAccount = useCallback(() => {
    setLocation("/accounts");
  }, [setLocation]);

  return (
    <AccountEmptyState
      onAddAccount={onAddAccount}
      title="Welcome to Net Worth Tracker!"
      description="Start by adding your first account, a bank account, savings account, or any account you want to track. Everything else builds from there."
      buttonLabel="Add Your First Account"
      ariaLabel="No financial data"
    />
  );
};
